import React from 'react'
import { InputWrapperIcon } from '@features/pricing/PricingCardControllers/styled'
import { InputSelect, InputSelectOption } from '@components/Form/InputSelect'
import ReactTooltip from 'react-tooltip'
import { Button } from '@components/Basic/ButtonNbe'
import { IoIosHelpCircleOutline } from 'react-icons/io'
import { useTranslation } from 'react-i18next'

interface Props {
  optionsMtu: InputSelectOption[]
  optionsBridge: InputSelectOption[]
  isCurrentPlan: boolean
  onPlanSelect: () => void
  remainDays: number
}

export const FreemiumControllers: React.FC<Props> = ({
  optionsBridge,
  optionsMtu,
  isCurrentPlan,
  onPlanSelect,
  remainDays,
}) => {
  const { t } = useTranslation()
  const defaultMtuForFreemium = [
    { value: '100', label: `100 ${t('billing.pricing.mtuOption')}` },
  ]
  const defaultBridgeForFreemium = [{ value: '1', label: '1 Bridge' }]

  // Temporary solution to render the page, waiting the API to be updated.
  // Api should return `freemium` within the plans, once this has been adde
  // we can remove this defaults values
  const optionsMtuWithDefault =
    optionsMtu && optionsMtu.length ? optionsMtu : defaultMtuForFreemium
  const optionsBridgesWithDefault =
    optionsBridge && optionsBridge.length
      ? optionsBridge
      : defaultBridgeForFreemium

  return (
    <>
      <InputWrapperIcon>
        <InputSelect
          $hasMargin
          disabled
          name={'FreePlan'}
          $options={optionsMtuWithDefault}
          value={optionsMtuWithDefault[0].value}
        />
        <IoIosHelpCircleOutline
          size={20}
          data-tip={t('billing.pricing.freemiumMtuTooltip')}
          data-for={'freemium-mtu-limit'}
          data-class='tooltip-style'
        />
        <ReactTooltip id={'freemium-mtu-limit'} />
      </InputWrapperIcon>

      <InputWrapperIcon>
        <InputSelect
          disabled
          name={'FreePlan'}
          $options={optionsBridgesWithDefault}
          value={optionsBridgesWithDefault[0].value}
        />
        <IoIosHelpCircleOutline
          size={20}
          data-tip={t('billing.pricing.freemiumBridgeTooltip')}
          data-for={'freemium-bridge-limit'}
          data-class='tooltip-style'
        />
        <ReactTooltip id={'freemium-bridge-limit'} />
      </InputWrapperIcon>
      <Button
        onClick={onPlanSelect}
        disabled={isCurrentPlan || remainDays > 0}
        $fluid
        $size={'standard'}
        $variant={'primary'}
      >
        {isCurrentPlan
          ? t('billing.pricing.ctaCurrentPlan')
          : t('billing.pricing.ctaChoosePlan')}
      </Button>
    </>
  )
}
